import axios from 'axios';
import { getHeaders } from '../utils/utils';

const API_BASE = '/api/referrals';

// Validate referral code
export const validateReferralCode = async (code) => {
  try {
    const response = await axios.get(`${API_BASE}/validate/${code}`);
    return response.data;
  } catch (error) {
    console.error('Error validating referral code:', error);
    throw error;
  }
};

// Get current user's referral info
export const getMyReferralInfo = async () => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/my/info`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting referral info:', error);
    throw error;
  }
};

// Get current user's referral stats
export const getMyReferralStats = async () => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/my/stats`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting referral stats:', error);
    throw error;
  }
};

// Admin: Get all referral statistics
export const getAdminReferralStats = async (filters = {}) => {
  try {
    const headers = getHeaders();
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await axios.get(`${API_BASE}/admin/stats?${params.toString()}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting admin stats:', error);
    throw error;
  }
};

// Admin: Get leaderboard
export const getLeaderboard = async (limit = 50) => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/admin/leaderboard?limit=${limit}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting leaderboard:', error);
    throw error;
  }
};

// Admin: Get specific user's referral data
export const getUserReferralData = async (userId) => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/admin/user/${userId}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting user referral data:', error);
    throw error;
  }
};

// Admin: Adjust user balance
export const adjustUserBalance = async (userId, creditAmount, cashAmount, reason) => {
  try {
    const headers = getHeaders();
    const response = await axios.post(`${API_BASE}/admin/user/${userId}/balance`, {
      creditAmount,
      cashAmount,
      reason,
    }, { headers });
    return response.data;
  } catch (error) {
    console.error('Error adjusting user balance:', error);
    throw error;
  }
};

// Admin: Update referral status
export const updateReferralStatus = async (referralId, status, notes) => {
  try {
    const headers = getHeaders();
    const response = await axios.put(`${API_BASE}/admin/referral/${referralId}/status`, {
      status,
      notes,
    }, { headers });
    return response.data;
  } catch (error) {
    console.error('Error updating referral status:', error);
    throw error;
  }
};

// Admin: Get referral details
export const getReferralDetails = async (referralId) => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/admin/referral/${referralId}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting referral details:', error);
    throw error;
  }
};

// Admin: Get milestones
export const getMilestones = async () => {
  try {
    const headers = getHeaders();
    const response = await axios.get(`${API_BASE}/admin/milestones`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error getting milestones:', error);
    throw error;
  }
};

// Admin: Create or update milestone
export const saveMilestone = async (id, data) => {
  try {
    const headers = getHeaders();
    const response = await axios.post(`${API_BASE}/admin/milestones/${id || 'new'}`, data, { headers });
    return response.data;
  } catch (error) {
    console.error('Error saving milestone:', error);
    throw error;
  }
};

// Admin: Delete milestone
export const deleteMilestone = async (id) => {
  try {
    const headers = getHeaders();
    const response = await axios.delete(`${API_BASE}/admin/milestones/${id}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error deleting milestone:', error);
    throw error;
  }
};

// Admin: Export referral data
export const exportReferralData = async (filters = {}) => {
  try {
    const headers = getHeaders();
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status) params.append('status', filters.status);

    const response = await axios.get(`${API_BASE}/admin/export?${params.toString()}`, {
      headers,
      responseType: 'blob',
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `referrals-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    return true;
  } catch (error) {
    console.error('Error exporting referral data:', error);
    throw error;
  }
};
